import api from "./api";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_DEPARTMENTS = API_URL_VERSION + "departamentos";

export const departmentService = {
  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_DEPARTMENTS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "department.messages.errors.find";
    }
  },
  list: async (params) => {
    try {
      const response = await api.get(ENDPOINT_DEPARTMENTS);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "department.messages.errors.list";
    }
  },
};
